import { datadogLogs } from "@datadog/browser-logs";

export function logFulfillmentGroupUpdateBatch(event: {
  multipleUpdates: boolean;
}) {
  datadogLogs.logger.info("Fulfillment group optimistic update batch", event);
}
